/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


// $(document).on('click', ".featured-product__wrapper .video_play_icon", function(){
//   var video = $(this).closest('.image-video-block').find('video').get(0);
//   var play_button = $(this).closest('.image-video-block').find('.video_play_icon');
//   var video_image = $(this).closest('.image-video-block').find('.img');
//   if (video.paused) {
//     video.play();
//     video.setAttribute("controls", "true");
//     play_button.hide();
//     video_image.css("z-index", "-1");
    
//   } else {
//     video.pause();
//     video.removeAttribute("controls");
//     play_button.show();
//     video_image.css("z-index", "1");
//   }
// });

$(document).ready(function() {
      
  $('.video_play_icon').on('click', function() {
    var videoSrc = $(this).siblings('video').find('source').attr('src');
    
    var videoTag = `
      <video controls autoplay playsinline loop preload="metadata">
        <source src="`+videoSrc+`" type="video/mp4">
      </video>
    `;
    
    $('.video_content').html(videoTag);
    $('#popup-open').fadeIn();
  });

  $('.quick-close').on('click', function() {
    $('#popup-open').fadeOut();
    $('.video_content').html('');
  });

  $(document).on('click', '.video_muted_btn', function() {
  var video = $('#popup-open video').get(0);
      if(video) {
        if(video.muted) {
            video.muted = false;
          $(".video_popup .inner .video_muted_btn .unmuted").css("display", "block");
          $(".video_popup .inner .video_muted_btn .muted").css("display", "none");
        } else {
            video.muted = true;
            $(".video_popup .inner .video_muted_btn .muted").css("display", "block");
            $(".video_popup .inner .video_muted_btn .unmuted").css("display", "none");
        }
      }
  });
});


$(document).on("click", function(event) {
  if ($(".video_popup").length) {
    if (!$(event.target).closest('.popup-content').length && !$(event.target).closest('.video_play_icon').length && !$(event.target).parents(".logo_with_icon").length) {
      $('#popup-open').fadeOut();
      $('.video_content').html('');
    }
  }
});

var $modal,$originalWrapper;
$('a[data-toggle="modal"]').on("click", function(e){
  e.preventDefault();
  const modal_id = $(this).attr("data-target");
  $modal = $(modal_id+'.modal');
  
  if($modal.length) {
    $originalWrapper = $modal.parent();  
    $('body').append($modal);
    $modal[0].offsetHeight;
    $modal.addClass("show");
    $('body').addClass('modal-open');
  }
});
$('button[data-dismiss="modal"]').on("click",function(){
  $modal.one('transitionend', function () {
    $modal.detach().appendTo($originalWrapper);
    $('body').removeClass('modal-open');
  });
  
  $modal.removeClass("show");
});

$('.modal').on("click", function(e){
  if($modal && $originalWrapper) {
    if(e.target == $modal[0]) {
      $modal.one('transitionend', function () {
        $modal.detach().appendTo($originalWrapper);
        $('body').removeClass('modal-open');
      });
      
      $modal.removeClass("show");
    }
  }
});
